import React, { useState, useRef, useEffect } from 'react';

interface UserMenuProps {
  username: string;
  onSignOut: () => void;
  isDark: boolean;
  onToggleTheme: () => void;
}

export const UserMenu: React.FC<UserMenuProps> = ({ username, onSignOut, isDark, onToggleTheme }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getInitials = (name: string) => {
    const words = name.trim().split(/\s+/);
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-10 h-10 rounded-full bg-gray-300 dark:bg-gray-600 text-gray-800 dark:text-white text-sm font-semibold flex items-center justify-center hover:bg-gray-400 dark:hover:bg-gray-500 transition-colors"
      >
        {getInitials(username)}
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border dark:border-gray-700 py-1 z-50">
          <div className="px-4 py-2 border-b dark:border-gray-700">
            <p className="text-sm font-medium text-gray-900 dark:text-white">{username}</p>
          </div>
          <button
            onClick={onToggleTheme}
            className="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center justify-between"
          >
            <span>{isDark ? 'Light Mode' : 'Dark Mode'}</span>
            <span>{isDark ? '☀️' : '🌙'}</span>
          </button>
          <button
            onClick={onSignOut}
            className="w-full text-left px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};
